import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Benefits = () => {
  return <ErpTablePage moduleKey="hrm_benefits" />;
};

export default Benefits;